import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Download APK Latest Update 2026`,
			keywords: 'GB WhatsApp, GB WhatsApp Download, GB WhatsApp APK',
			description: `Download GB WhatsApp APK v18.80 for Android (2026) with advanced privacy, themes, ghost mode, and more. Enjoy secure, anti-ban features and powerful customization.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/'
				}
			]
		},
		component: Home,
	},
	{
		path: '/download/',
		name: 'en-download',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GBWhatsApp APK Information and Safety Notes',
			keywords: 'GB WhatsApp APK information, GB WhatsApp safety notes',
			description: 'Read GBWhatsApp APK version details, Android compatibility notes, and safety guidance. Direct APK distribution is currently unavailable on this site.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/download/'
				}
			]
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/about/',
		name: 'about',
		meta: {
			appname: 'GBWhatsApp',
			title: 'About Us',
			keywords: 'About GB WhatsApp resource website',
			description: 'Learn about our GB WhatsApp resource website, including version updates, installation guides, feature explanations, and APK download resources.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/about/'
				}
			]
		},
		component: () => import('@/views/about.vue'),
	},
	{
		path: '/privacy/',
		name: 'privacy',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Privacy Policy',
			keywords: 'Privacy Policy',
			description: 'Read the Privacy Policy for gbappsdl.org and learn how information may be collected and used when you visit our website.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/privacy/'
				}
			]
		},
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Disclaimer',
			keywords: 'Disclaimer',
			description: 'Read the gbappsdl.org disclaimer about GB WhatsApp information, trademarks, third-party application risks, and external links.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/disclaimer/'
				}
			]
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/blog/',
		name: 'blog',
		meta: {
			appname: 'GBWhatsApp',
			title: `Latest GB Blog Posts & Updates`,
			keywords: 'blogs',
			description: `Stay updated with a wide range of topics about GB WhatsApp in our site. Hope these blogs can help you use GBWhatsApp easily.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbappsdl.org/blog/`,
				},
			],
		},
		component: () => import('@/views/blogs.vue'),
	},
	{
		path: '/send-messages-to-unsaved-numbers-gbwhatsapp/',
		name: 'send-messages-to-unsaved-numbers-gbwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `Send Messages to Unsaved Numbers in GB WhatsApp`,
			keywords: 'send messages to unsaved numbers in GB WhatsApp',
			description: `Learn to send messages to unsaved numbers in GB WhatsApp. Improve business communication, streamline customer support, and maintain privacy while using the app safely and efficiently.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbappsdl.org/send-messages-to-unsaved-numbers-gbwhatsapp/`,
				},
			],
		},
		component: () => import('@/views/blog-1.vue'),
	},
	{
		path: '/themes/',
		name: 'themes',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Best GB WhatsApp Themes 2026 - iOS, Dark & Anime XML Skins',
			keywords: 'GB WhatsApp themes, iOS style, dark mode, anime, XML skins',
			description: 'Download premium GB WhatsApp themes including iOS style, dark mode, anime, and minimalist XML skins for v18.80. Fast install and updated for 2026.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/themes/'
				}
			]
		},
		component: () => import('@/views/themes.vue'),
	},
	{
		path: '/help-center/',
		name: 'help-center',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp Help Center - Troubleshooting, Tips & Anti-Ban Guides',
			keywords: 'GB WhatsApp help, troubleshooting, anti-ban, ghost mode',
			description: 'Learn how to fix GB WhatsApp errors, enable Ghost Mode, restore chats, avoid bans, and update safely with our detailed help center guides.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/help-center/'
				}
			]
		},
		component: () => import('@/views/help-center.vue'),
	},
	{
		path: '/how-to-use-two-whatsapp-accounts-with-gbwhatsapp/',
		name: 'how-to-use-two-whatsapp-accounts-with-gbwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: 'How to Use Two WhatsApp Accounts with GBWhatsApp',
			keywords: 'two whatsapp accounts, dual whatsapp, gbwhatsapp multiple accounts',
			description: 'A complete guide on running dual WhatsApp accounts on a single Android device using GBWhatsApp. Step-by-step instructions and tips.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/how-to-use-two-whatsapp-accounts-with-gbwhatsapp/'
				}
			]
		},
		component: () => import('@/views/blog-2.vue'),
	},
	{
		path: '/can-you-use-gbwhatsapp-without-getting-banned/',
		name: 'can-you-use-gbwhatsapp-without-getting-banned',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Can You Use GBWhatsApp Without Getting Banned?',
			keywords: 'gbwhatsapp anti ban, safe gbwhatsapp, avoid whatsapp ban',
			description: 'Discover the truth about GBWhatsApp bans. Learn practical tips, anti-ban features, and safe usage practices to protect your account.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/can-you-use-gbwhatsapp-without-getting-banned/'
				}
			]
		},
		component: () => import('@/views/blog-3.vue'),
	},
	{
		path: '/why-some-gbwhatsapp-versions-stop-working-suddenly/',
		name: 'why-some-gbwhatsapp-versions-stop-working-suddenly',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Why Some GBWhatsApp Versions Stop Working Suddenly',
			keywords: 'gbwhatsapp stopped working, gbwhatsapp expired, fix gbwhatsapp crash',
			description: 'Find out why your GBWhatsApp suddenly stopped working. We explain the common causes like forced updates, expired versions, and how to fix them.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/why-some-gbwhatsapp-versions-stop-working-suddenly/'
				}
			]
		},
		component: () => import('@/views/blog-4.vue'),
	},
	{
		path: '/recover-deleted-messages-gb-whatsapp/',
		name: 'recover-deleted-messages-gb-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: 'How to Recover Deleted Messages in GB WhatsApp (2026)',
			keywords: 'recover deleted messages gb whatsapp, anti-delete messages gb whatsapp',
			description: 'Recover deleted messages in GB WhatsApp by enabling the Anti-Delete Messages feature. View messages even after the sender deletes them.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/recover-deleted-messages-gb-whatsapp/'
				}
			]
		},
		component: () => import('@/views/blog-5.vue'),
	},
	{
		path: '/change-dp-photo-corners-gb-whatsapp/',
		name: 'change-dp-photo-corners-gb-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: 'How to Change DP Photo Corners in GB WhatsApp (2026)',
			keywords: 'dp photo corners gb whatsapp, change profile photo corners gb whatsapp',
			description: 'Learn how to change DP Photo Corners in GB WhatsApp by opening GB Settings > Universal > DP Photo Corners, selecting your preferred style, and saving the changes.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/change-dp-photo-corners-gb-whatsapp/'
				}
			]
		},
		component: () => import('@/views/blog-6.vue'),
	},
	{
		path: '/is-gb-whatsapp-safe-to-use/',
		name: 'is-gb-whatsapp-safe-to-use',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Is GB WhatsApp Safe to Use? Security and Privacy Risks',
			keywords: 'is gb whatsapp safe, gb whatsapp security, gb whatsapp privacy risks',
			description: 'Is GB WhatsApp safe to use? Learn about its security, privacy, account ban risks, APK downloads, and what to consider before installing it.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappsdl.org/is-gb-whatsapp-safe-to-use/'
				}
			]
		},
		component: () => import('@/views/blog-7.vue'),
	},
]

let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
